import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  formData: {
    provider: '',
    renderingFacility: '',
    taxId: '',
    ptName: '',
    dob: '',
    ssn: '',
    employer: '',
    doi: [{ value: '' }],
    adjNumber: [{ value: '' }],
    insurance: '',
    bill: '',
    paid: '',
    outstanding: '',
    fds: '',
    lds: '',
    solDate: '',
    ledger: 'not required',
    hcf: 'not required',
    invoice: 'not required',
    signinSheet: 'not required',
    hearingStatus: '',
    hearingDate: '',
    hearingTime: '',
    judgeName: '',
    courtRoomlink: '',
    judgePhone: '',
    AccesCode: '',
    boardLocation: '',
    lienStatus: '',
    caseStatus: '',
    caseDate: '',
    crAmount: '',
    dorFiledBy: '',
    status4903_8: '',
    pmrStatus: '',
    judgeOrderStatus: '',
    adjuster: '',
    adjusterPhone: '',
    adjusterFax: '',
    adjusterEmail: '',
    defenseAttorney: '',
    defenseAttorneyPhone: '',
    defenseAttorneyFax: '',
    defenseAttorneyEmail: '',
    claimNo: [{ value: '' }],
  },
};

const manualRecordFormSlice = createSlice({
  name: 'manualRecordForm',
  initialState,
  reducers: {
    setFormField(state, action) {
      const { name, value } = action.payload;
      const next = { ...state.formData, [name]: value };

      if (name === 'bill' || name === 'paid') {
        const bill = name === 'bill' ? parseFloat(value) : parseFloat(next.bill);
        const paid = name === 'paid' ? parseFloat(value) : parseFloat(next.paid);
        const safeBill = Number.isNaN(bill) ? 0 : bill;
        const safePaid = Number.isNaN(paid) ? 0 : paid;
        next.outstanding = (safeBill - safePaid).toFixed(2);
      }

      if (name === 'lds') {
        if (value) {
          const ldsDate = new Date(value);
          if (!Number.isNaN(ldsDate.getTime())) {
            ldsDate.setMonth(ldsDate.getMonth() + 18);
            const year = ldsDate.getFullYear();
            const month = String(ldsDate.getMonth() + 1).padStart(2, '0');
            const day = String(ldsDate.getDate()).padStart(2, '0');
            next.solDate = `${year}-${month}-${day}`;
          }
        } else {
          next.solDate = '';
        }
      }

      state.formData = next;
    },
    setMultiEntry(state, action) {
      const { field, index, value } = action.payload;
      const updatedEntries = [...state.formData[field]];
      updatedEntries[index] = { ...updatedEntries[index], value };
      state.formData = { ...state.formData, [field]: updatedEntries };
    },
    addMultiEntry(state, action) {
      const field = action.payload;
      state.formData = {
        ...state.formData,
        [field]: [...state.formData[field], { value: '' }],
      };
    },
    removeMultiEntry(state, action) {
      const { field, index } = action.payload;
      const updatedEntries = [...state.formData[field]];
      updatedEntries.splice(index, 1);
      state.formData = { ...state.formData, [field]: updatedEntries };
    },
    resetManualRecordForm(state) {
      state.formData = initialState.formData;
    },
  },
});

export const {
  setFormField,
  setMultiEntry,
  addMultiEntry,
  removeMultiEntry,
  resetManualRecordForm,
} = manualRecordFormSlice.actions;

export const selectManualRecordFormData = (state) => state.manualRecordForm.formData;

export default manualRecordFormSlice.reducer;
